import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=329656ba"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../gitee/am-dropshipping-mb/ux/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.108.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports